import React from 'react';

interface MobileMenuToggleProps {
    isOpen: boolean;
    onToggle: () => void;
    isDark: boolean;
}

const MobileMenuToggle: React.FC<MobileMenuToggleProps> = ({ isOpen, onToggle, isDark }) => {
    return (
        <button
            className={`hide-above-991 cursor-pointer ms-4 py-1 px-3 text-xl leading-none rounded-sm bg-[var(--color-green-100)] border border-transparent transition-shadow duration-150 ease-in-out ${isDark ? 'text-white' : ''
                }`}
            style={isDark ? { borderColor: 'rgba(255, 255, 255, 0.1)' } : undefined}
            type="button"
            onClick={onToggle}
            aria-controls="navbarNav"
            aria-expanded={isOpen}
            aria-label="Toggle navigation"
        >
            <span
                className="inline-block w-8 h-8 align-middle bg-no-repeat bg-center bg-[length:100%_100%] leading-none bg-[var(--color-green-100)] border border-transparent"
                style={{
                    backgroundImage:
                        "url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='%23181A20' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\")",
                }}
            ></span>

        </button>

    );
};

export default MobileMenuToggle;
